export default {
  state: {
    supervision: null
  },
  mutations: {
    setSupervision(state, value) {
      state.supervision = value
    },
  },
};
